var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgOneWayArrow = function SvgOneWayArrow(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 15,
    fill: "none",
    viewBox: "0 0 13 15",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#979797",
    d: "M8.652 11c-.234 0-.502-.084-.703-.252-.4-.307-.4-.839 0-1.175l2.074-1.734H.84C.376 7.84 0 7.463 0 7c0-.463.376-.84.84-.84h9.183L7.95 4.428c-.4-.308-.4-.84 0-1.175.368-.336 1.004-.336 1.405 0l3.044 2.545c.401.308.602.755.602 1.203 0 .448-.2.867-.602 1.203l-3.044 2.545c-.2.168-.468.252-.702.252z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgOneWayArrow);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/one-way-arrow.471939d955d241148940c36b5b300dbe.svg";